import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpCommunity'

export const getUsers = (params = '') => Http.get(`/users/fetch${serialize(params)}`)

/**
 * Lightweight user lookup for select/autocomplete dropdowns.
 * Returns only id, name, nickname, avatar_url — no subscription/wallet overhead.
 * Pass { term } for search or { id } to resolve a specific user (edit mode).
 */
export const getUsersSelect = (params = {}) => Http.get(`/users/select${serialize(params)}`)
